
import { Report } from "./../Reports/Report.js";

/* ==----------------------------------------------------------------------------------------------------------== */
/* ==----------------------------------------== Global definitions ==------------------------------------------== */
/* ==----------------------------------------------------------------------------------------------------------== */

export const FileType = {
    BLOB: 0,
    PLAIN: 1
}

/* ==----------------------------------------------------------------------------------------------------------== */
/* ==----------------------------------------== Class definitions ==-------------------------------------------== */
/* ==----------------------------------------------------------------------------------------------------------== */

/**
 * @description Abstract class representing a File with varying content types
 * 
 * [ MUST OVERRIDE ]
 *      getFileType();
 *      getContentAsBlob();
 * [ CAN OVERRIDE ]
 *      handlesDownloads();
 * */
export class FileNode {

    /**
     * @description Basic constructor that creates a FileNode using a name
     * @param { String } name
     * @param { any } content
     */
    constructor(name, content = null) {
        this.name = name;
        this.content = content;
    }

    /**
     * @description Returns true if the file has content
     * @returns { Boolean }
     * */
    hasContent() {
        return this.content !== null;
    }

    /**
     * [ MUST OVERRIDE ]
     * @description Returns the FileNode's FileType
     * @returns { FileType }
     * */
    getFileType() {
        throw new Error("Unable to execute 'getFileType' from abstract class FileNode");
    }

    /**
     * [ MUST OVERRIDE ]
     * @description Converts the current content to a blob
     * @returns { Blob }
     * */
    getContentAsBlob() {
        throw new Error("Unable to execute 'getContentAsBlob' from abstract class FileNode");
    }

    /**
     * [ CAN OVERRIDE ]
     * @description Specifies wether the filenode can download content
     * @returns { Boolean } Handles?
     * */
    handlesDownloads() {
        return false;
    }

    /**
     * @description Saves the file to the downloads folder
     * @returns { Report } success?
     * */
    save() {
        if (!this.hasContent()) {
            console.log("No content to save for file " + this.name);

            return Report.ko();
        }

        let blob = this.getContentAsBlob();

        if (blob === null) {
            return Report.ko();
        }

        try {
            let outputUrl = URL.createObjectURL(blob);
            let link = document.createElement("a");

            link.href = outputUrl;
            link.download = this.name;

            link.click();
        } catch (error) {
            console.log(error);
            return Report.ko();
        };

        return Report.ok();
    }
}
